import Vue from 'vue';
import Router from 'vue-router';
import { dirname } from 'src/utils';
import { routes, beforeEach } from 'src/router/routes';

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'active',
  mode: process.env.VUE_APP_DEPLOY === 'subfolder' ? 'hash' : 'history',
  base: dirname,
  routes,
});

router.beforeEach((to, from, next) => {
  beforeEach(to, from, next);
});

export default router;
